export default class FeedbackBar {

    constructor() {
        this.bar = document.getElementById( 'feedback-bar' );
    }

    init() {
        if ( ! this.bar ) return;

        this.question   = this.bar.querySelector( '[data-feedback-question]' );
        this.panels     = this.bar.querySelectorAll( '[data-feedback-panel]' );
        this.voteButtons = this.bar.querySelectorAll( '[data-feedback]' );
        this.reportBtn  = this.bar.querySelector( '[data-feedback-toggle="report"]' );
        this.cancelBtns = this.bar.querySelectorAll( '[data-feedback-cancel]' );
        this.submitBtns = this.bar.querySelectorAll( '[data-feedback-submit]' );

        this.voteButtons.forEach( btn => {
            btn.addEventListener( 'click', () => this.handleVote( btn.dataset.feedback ) );
        });

        if ( this.reportBtn ) {
            this.reportBtn.addEventListener( 'click', () => this.showPanel( 'report' ) );
        }

        this.cancelBtns.forEach( btn => {
            btn.addEventListener( 'click', () => this.reset() );
        });

        this.submitBtns.forEach( btn => {
            btn.addEventListener( 'click', () => this.handleSubmit( btn.dataset.feedbackSubmit ) );
        });
    }

    handleVote( type ) {
        if ( type === 'yes' ) {
            this.submit( type, '' ).then( () => this.showPanel( 'thanks' ) );
        } else {
            this.showPanel( 'no' );
        }
    }

    showPanel( name ) {
        this.question.hidden = true;
        this.panels.forEach( panel => {
            panel.hidden = panel.dataset.feedbackPanel !== name;
        });
    }

    reset() {
        this.question.hidden = false;
        this.panels.forEach( panel => { panel.hidden = true; });
        this.bar.querySelectorAll( '[data-feedback-message]' ).forEach( ta => { ta.value = ''; });
    }

    handleSubmit( type ) {
        const panel   = this.bar.querySelector( `[data-feedback-panel="${type}"]` );
        const textarea = panel ? panel.querySelector( '[data-feedback-message]' ) : null;
        const message  = textarea ? textarea.value.trim() : '';

        if ( type === 'report' && ! message ) {
            textarea.focus();
            return;
        }

        const btn = this.bar.querySelector( `[data-feedback-submit="${type}"]` );
        if ( btn ) btn.disabled = true;

        this.submit( type, message )
            .then( () => this.showPanel( 'thanks' ) )
            .catch( () => {
                if ( btn ) btn.disabled = false;
            });
    }

    submit( type, message ) {
        const data = new FormData();
        data.append( 'action',   'diocese_page_feedback' );
        data.append( 'nonce',    dioceseFeedback.nonce );
        data.append( 'type',     type );
        data.append( 'message',  message );
        data.append( 'post_id',  dioceseFeedback.postId );
        data.append( 'page_url', window.location.href );

        return fetch( dioceseFeedback.ajaxUrl, { method: 'POST', body: data } )
            .then( res => res.json() )
            .then( json => {
                if ( ! json.success ) throw new Error( json.data?.message || 'Error' );
                return json;
            });
    }

}
